import { render } from 'preact';
import { OnboardingApp } from './OnboardingApp';
import './styles.css';

render(<OnboardingApp />, document.getElementById('app'));
